import { LoginCta, PrimaryLink } from "./NudgeShared";
import ExpandChevron from "assets/chevron-up.svg";
import styles from "./NudgeCompressed.module.scss";
import sharedStyles from "./NudgeShared.module.scss";
import cx from "classnames";

type NudgeProps = {
  title: string;
  count: number;
  pageViews: number;
  firstArticle: boolean;
  lastArticle: boolean;
  mobileTitle: string;
  setShowExpanded: (showExpanded: boolean) => void;
  setManuallyExpanded: (manuallyExpanded: boolean) => void;
  setSlidingDirection: (slidingDirection: string) => void;
};

const NudgeCompressed = ({
  title,
  count,
  pageViews,
  firstArticle,
  lastArticle,
  mobileTitle,
  setShowExpanded,
  setManuallyExpanded,
  setSlidingDirection,
}: NudgeProps) => {
  return (
    <div
      className={styles.root}
      id="nudge"
      data-testid="nudge"
      data-category="nudge interaction"
      data-label="nudge-compressed"
    >
      <div
        className={styles.desktop}
        data-action="nudge:display"
        data-label="nudge-compressed"
      >
        <div className={styles.text}>
          {!firstArticle && !lastArticle && (
            <span
              className={cx(
                styles.count,
                "nudge-compressed__article-count-number--desktop"
              )}
            >
              {count}
            </span>
          )}
          <h3
            className={cx(
              styles.title,
              styles.borderRight,
              lastArticle && styles.emphasizedText,
              "nudge-compressed__title--desktop"
            )}
          >
            {title}
          </h3>
          <LoginCta includeText={false} source="nudge-compressed" />
        </div>
        <PrimaryLink
          text={"Subscribe Now"}
          source={"nudge-compressed"}
          count={pageViews}
          isExpandedStyles={false}
        />
      </div>
      <div className={styles.mobileTitleContainer}>
        {firstArticle && (
          <PrimaryLink
            text={mobileTitle}
            source={"nudge-compressed"}
            count={pageViews}
            isExpandedStyles={false}
            isCentered={true}
            mobileOnly={true}
          />
        )}
        {!firstArticle && (
          <div className={styles.textMobile}>
            {count != 0 && count != 1 && (
              <div>
                <span
                  className={cx(
                    styles.count,
                    "nudge-compressed__article-count-number--mobile"
                  )}
                >
                  {count}
                </span>
                <h3
                  className={cx(
                    styles.title,
                    "nudge-compressed__article-count-text--mobile"
                  )}
                >
                  more free articles
                </h3>
              </div>
            )}
            {count === 1 && (
              <div>
                <span
                  className={cx(
                    styles.count,
                    "nudge-compressed__article-count-number--mobile"
                  )}
                >
                  {count}
                </span>
                <h3
                  className={cx(
                    styles.title,
                    "nudge-compressed__article-count-text--mobile"
                  )}
                >
                  more free article
                </h3>
              </div>
            )}
            {/* last article is different text because dont ask */}
            {count === 0 && (
              <div>
                <h3
                  className={cx(
                    styles.emphasizedText,
                    "nudge-compressed__article-count-text--mobile"
                  )}
                >
                  This is your last free article.
                </h3>
              </div>
            )}
            <PrimaryLink
              text={"Subscribe Now"}
              source={"nudge-compressed"}
              count={pageViews}
              isExpandedStyles={false}
              isCentered={false}
              mobileOnly={true}
            />
          </div>
        )}
      </div>
      <button
        className={cx(sharedStyles.chevron, styles.chevronCompressed)}
        aria-label="Read more"
        aria-pressed="false"
        data-action="nudge:user_expand"
        data-label="nudge-compressed"
        onClick={() => {
          setSlidingDirection("up");
          setTimeout(() => {
            setShowExpanded(true);
            setManuallyExpanded(true);
            setSlidingDirection("none");
          }, 100);
        }}
      >
        <ExpandChevron focusable="false" />
      </button>
    </div>
  );
};

export default NudgeCompressed;
